import * as XLSX from 'xlsx'

export default ({ fileName, headers, data }) => {
  const workbook = XLSX.utils.book_new()
  const workSheet = XLSX.utils.aoa_to_sheet([headers, ...data])
  XLSX.utils.book_append_sheet(workbook, workSheet, 'Data')
  /* output format determined by filename */
  XLSX.writeFile(workbook, fileName)
  /* at this point, the file will have been downloaded */
}
